import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Building2, User, Truck, BookOpenCheck } from 'lucide-react';
import { Detalhes } from '@/types/DetailNF'
import { formatCpfOrCnpj } from '@/utils/stringFormatter'
import { formatDataISO } from '@/utils/stringFormatter';

interface PropsDetail {
    detail: Detalhes
}

export function Details({ detail }: PropsDetail) {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 min-h-[380px]">
            <Card>
                <CardHeader className="pb-2">
                    <CardTitle className="flex items-center text-lg">
                        <Building2 className="w-5 h-5 mr-2" />
                        Fornecedor
                    </CardTitle>
                </CardHeader>
                <CardContent>
                    <dl className="space-y-2">
                        <dt className="text-sm font-medium text-muted-foreground">Nome Fantasia</dt>
                        <dd>{detail.NM_FANTASIA_FORNECEDOR}</dd>
                        <dt className="text-sm font-medium text-muted-foreground">CNPJ</dt>
                        <dd>{formatCpfOrCnpj(detail.DD_CNPJ_FORNECEDOR)}</dd>
                    </dl>
                </CardContent>
            </Card>

            <Card>
                <CardHeader className="pb-2">
                    <CardTitle className="flex items-center text-lg">
                        <User className="w-5 h-5 mr-2" />
                        Cliente
                    </CardTitle>
                </CardHeader>
                <CardContent>
                    <dl className="space-y-2">
                        <dt className="text-sm font-medium text-muted-foreground">Nome Fantasia</dt>
                        <dd>{detail.NM_FANTASIA_CLIENTE}</dd>
                        <dt className="text-sm font-medium text-muted-foreground">CNPJ</dt>
                        <dd>{formatCpfOrCnpj(detail.DD_CNPJ_CLIENTE)}</dd>
                    </dl>
                </CardContent>
            </Card>

            <Card >
                <CardHeader className="pb-2">
                    <CardTitle className="flex items-center text-lg">
                        <Truck className="w-5 h-5 mr-2" />
                        Transportadora
                    </CardTitle>
                </CardHeader>
                <CardContent>
                    <dl className="space-y-2">
                        <dt className="text-sm font-medium text-muted-foreground">Nome Fantasia</dt>
                        <dd>{detail.NM_FANTASIA_TRANSPORTADORA}</dd>
                        <dt className="text-sm font-medium text-muted-foreground">CNPJ</dt>
                        <dd>{detail.DD_CNPJ_TRANSPORTADORA && formatCpfOrCnpj(detail.DD_CNPJ_TRANSPORTADORA)}</dd>
                    </dl>
                </CardContent>
            </Card>
            <Card>
                <CardHeader className="pb-2">
                    <CardTitle className="flex items-center text-lg">
                        <BookOpenCheck className="w-5 h-5 mr-2" />
                        Reconhecimento
                    </CardTitle>
                </CardHeader>
                <CardContent>
                    {detail.DT_RECONHECIMENTO ? (
                        <dl className="space-y-2">
                            <dt className="text-sm font-medium text-muted-foreground">Data de Reconhecimento</dt>
                            <dd> {formatDataISO(detail.DT_RECONHECIMENTO)} </dd>
                            <dt className="text-sm font-medium text-muted-foreground">Número CT-e - Série</dt>
                            <dd>{detail.DD_DOC_CTE} - {detail.DD_SERIE_DCTE}</dd> 
                        </dl> 
                    ) : (
                    <span>
                        Aguardando conhecimento do CT-e
                    </span>
                    )} 
                </CardContent>
            </Card>
        </div>
    );
}